import { Injectable } from '@angular/core';
import { CustomHttp } from './custom-http.service';
import { UserSetting, UserSettingDefinition, VirtualMetricsAPIModel } from './user-settings.types';
import { Observable } from 'rxjs';
import { Constants } from 'environments/constants';
import { encodeAndIsoDate } from '@sportlogiq/shared';

@Injectable()
export class UserSettingsService {
    constructor(
        private _http: CustomHttp
    ) {}

    public fetchVirtualMetrics(): Observable<VirtualMetricsAPIModel> {
        return this._http.get('/metrics/virtualenumsdefinitions');
    }

    public fetchUserSettingsDefinitions(): Observable<UserSettingDefinition[]> {
        return this._http.get('/usersettingdefinitions', undefined, Constants.api_root_v3);
    }

    public fetchUserSettings(): Observable<UserSetting[]> {
        return this._http.get('/usersettings', undefined, Constants.api_root_v3).pipe();
    }

    public saveUserSettings(payload: UserSetting[]): Observable<void> {
        return this._http.post('/usersettings', payload, {}, Constants.api_root_v3);
    }

    public deleteUserSettings(userSettingId: string): Observable<string> {
        const queryParamString = `?updatedon=${encodeAndIsoDate(new Date())}`;
        return this._http.delete(`/usersettings/${userSettingId}${queryParamString}`, {}, Constants.api_root_v3);
    }
}
